// extracted by mini-css-extract-plugin
export default {"cls1":"TsXGQMKl2KIMJZ55ukz5","cls2":"MT4i5Wc_H9iT1LWL_wQN TsXGQMKl2KIMJZ55ukz5"};